const assessmentDecisionReviewers = [
    {
        'projectManager': 'Howard Wang',
        'reviewer': 'May Shih',
    },
    {
        'projectManager': 'Frank Lin',
        'reviewer': 'May Shih',
    },
    {
        'projectManager': 'Sam Lee',
        'reviewer': 'Winnie Huang',
    },
]

export default assessmentDecisionReviewers;